const BaseComponent = require('base/base-component');
const ESClient = require('helper/es-client');
const DateHelper = require('helper/date-helper');
const Server = require('helper/server');
const Config = require('helper/config');
const Query = require('helper/query');

const listTpl = Handlebars.templates['common/fullTextSearch/templates/listTpl'];
const selectListTpl = Handlebars.templates['common/fullTextSearch/templates/select-list'];

class FullTextSearchPage extends BaseComponent {
  constructor () {
    super({
      events: {
        'keydown [name=keyword]': 'enterSearch',
        'change .district': 'doSearch',
        'click .btnSearch': 'doSearch',
        'input .input-icon': 'showIcon',
        'click .icon-Shape': 'clearInput'
      }
    });
  }

  init () {
    this.$keyword = this.$el.find('[name=keyword]');
    this.$listContent = this.$el.find('.list-content');
    this.$date = this.$el.find('.date');
    this.$startDate = this.$el.find('.startDate');
    this.$endDate = this.$el.find('.endDate');
    this.$district = this.$el.find('.district');
    this.$pagination = this.$el.find('.pagination-container');
    this.$districtCondition = this.$el.find('.district').parents('.condition');

    this.client = new ESClient();
    this.pageNo = 1;
    this.pageSize = 15;
    this.query = new Query();

    this.$keyword.val(this.query.get('k'));

    // init
    this.$date.datetimepicker({
      format: 'yyyy-mm-dd',
      autoclose: true,
      maxView: 4,
      minView: 2,
      language: 'zh-CN'
    });

    this.$el.find('.js-timepoint li').on('click', e => this.handleTimepointChange(e));
    this.$el.find('.js-category li').on('click', e => this.handleCategoryChange(e));
    this.$el.find('.js-subCategory li').on('click', e => this.handleSubCategoryChange(e));

    this.fuzzyTime();
  }

  initDistrictTree () {
    const pId = Config.pId;
    // 清空原来的select
    this.$el.find('.district').html(selectListTpl([]));
    Server.getDistrictList({ pId }).then(({ data }) => {
      // 初始化城市选择下拉树
      this.$el.find('[name=city]').html(selectListTpl(data));
    });

    $('[name=city]').on('change', (e) => {
      this.$el
        .find('[name=area]')
        .find('[data-code]')
        .remove();

      // 初始化地区选择下拉树
      const $el = $(e.currentTarget);
      const id = $el.find(':selected').data('id');
      if (id) {
        Server.getDistrictList({ pId: id })
          .then(({ data }) => {
            this.$el.find('[name=area]').html(selectListTpl(data));
          });
      }
    });
  }

  /**
   * 根据选择的时间点，计算时间段
   *
   * @memberof FullTextSearchPage
   */
  fuzzyTime () {
    const t = this.$el.find('.js-timepoint .selected').data('num');
    const begin = this.dateBefore(t);
    this.$startDate.val(begin ? DateHelper.formatDate(begin) : '');
    this.$endDate.val(DateHelper.formatDate(new Date()));
    this.doSearch();
  }

  /**
   * 搜索框输入时触发
   *
   * @param {*} e
   * @memberof FullTextSearchPage
   */
  enterSearch (e) {
    e.keyCode == 13 && this.doSearch(true);
  }

  // 时间节点选择变更时触发
  handleTimepointChange (e) {
    const $el = $(e.currentTarget);
    $el
      .addClass('selected')
      .siblings('li')
      .removeClass('selected');

    this.fuzzyTime();
  }

  // 类型选择变更时触发
  handleCategoryChange (e) {
    const $el = $(e.currentTarget);
    $el
      .addClass('selected')
      .siblings('li')
      .removeClass('selected');
    const code = $el.data('num');
    if (code === 'ZcyAnnouncement') {
      this.$districtCondition.show();
      this.initDistrictTree();
    } else {
      this.$districtCondition.hide();
    }
    // 点击模块后显示对应类型
    this.$el.find('[data-code]').addClass('hide');
    this.$el.find(`[data-code="${code}"]`).removeClass('hide');
    // 点击模块后类型默认选中全部
    this.$el.find(`[data-code="${code}"] li`).removeClass('selected');
    this.$el
      .find(`[data-code="${code}"]`)
      .find('li:first-child')
      .addClass('selected');
    this.doSearch();
  }

  // 类型选择变更时触发
  handleSubCategoryChange (e) {
    const $el = $(e.currentTarget);
    $el
      .addClass('selected')
      .siblings('li')
      .removeClass('selected');
    this.doSearch();
  }

  /**
   * 计算val时间前的日期
   *
   * @param {*} val 可能值为 1d 2m all
   * @returns
   */
  dateBefore (val) {
    const t = /[a-z]$/.exec(val)[0];
    const n = /^[0-9]+/.exec(val) && /^[0-9]+/.exec(val)[0];
    const now = new Date();
    if (val === 'all') {
      return '';
    } else if (t === 'd') {
      return new Date(now.getFullYear(), now.getMonth(), now.getDate() - n);
    } else if (t === 'm') {
      return new Date(now.getFullYear(), now.getMonth() - n, now.getDate());
    }
  }

  /**
   * 进行搜索
   *
   * @param {boolean} [isRefresh=false] 是否刷新分页参数
   */
  doSearch (isRefresh = false) {
    if (isRefresh === true) {
      this.pageNo = 1;
    }

    const { pageNo, pageSize } = this;
    const keyword = this.$keyword.val();
    const category = this.$el.find('.js-category .selected').data('num');
    const subCategory = this.$el.find('.condition:not(.hide) .js-subCategory .selected').data('num');
    const begin = this.$startDate.val();
    const end = this.$endDate.val();
    const districtCode = this.$districtCondition.is(':visible') ?
      this.$district.last().val() || this.$district.first().val() :
      undefined;

    const requestData = {
      pageNo,
      pageSize,
      keyword,
      begin: Date.parse(begin) - 8 * 60 * 60 * 1000,
      end: Date.parse(end) + (16 * 60 * 60 * 1000 - 1),
      firstCode: category,
      secondCode: subCategory,
      districtCode
    };
    // 删除为空的搜索条件
    for (const k in requestData) {
      if (requestData[k] === '' || requestData[k] === null || requestData[k] === undefined) {
        delete requestData[k];
      }
    }
    this.client.searchArticle(requestData).then((res) => {
      const total = res.hits.total;
      if (total && total > 0) {
        this.initPagination(total, this.$pagination);
        this.$pagination.show();
      } else {
        this.$pagination.hide();
      }
      this.updateSeachInfo(total);
      this.$listContent.html(listTpl({ _DATA_: res.hits }));
    });
  }

  // 初始化分页器
  initPagination (count, wrap) {
    count > 9985 && (count = 9985);
    let sources = (function () {
      let result = [];
      for (let i = 0; i < count; i++) {
        result.push(i);
      }
      return result;
    })();

    const options = {
      dataSource: sources,
      totalNumber: count,
      pageSize: 15,
      pageNumber: this.pageNo,
      prevText: '上一页',
      nextText: '下一页',
      showGoInput: false,
      showGoButton: false,
      beforeGoButtonOnClick: (_, pageNumber) => {
        this.pageNo = pageNumber;
        this.doSearch();
      },
      beforePageOnClick: (_, pageNumber) => {
        this.pageNo = pageNumber;
        this.doSearch();
      },
      beforePreviousOnClick: () => {
        this.pageNo--;
        this.doSearch();
      },
      beforeNextOnClick: () => {
        this.pageNo++;
        this.doSearch();
      }
    };

    wrap.map((_, e) => $(e).pagination(options));
  }

  updateSeachInfo (total) {
    const key = this.$keyword.val();
    const start = this.$startDate.val();
    const end = this.$endDate.val();
    $('.search-info .search-key').text(key);
    $('.search-info .search-total').text(total);
    $('.search-info .search-start').text(start);
    $('.search-info .search-end').text(end);
  }

  showIcon (e) {
    const $ele = $(e.target || e.srcElement);
    if ($ele.val().length > 0) {
      this.$el.find('.icon-Shape').show();
    } else {
      this.$el.find('.icon-Shape').hide();
    }
  }

  clearInput (e) {
    let $searchInp = $('[name=keyword]');
    $searchInp.val('');
    $(e.target).hide();
    this.doSearch(true);
  }
}

module.exports = FullTextSearchPage;
